"use client";
import { useRef } from "react";
import CustomerCard from "./customerCard";
import images from "../constants/images";

const customers = [
  {
    name: "Naina",
    image: images.profile.src,
    story:
      "We used this app for our wedding invitations and it was worth the cost. The designs are elegant and easy to customize. It made the whole process fast and stress free.",
    color: "#F8312F",
  },
  {
    name: "Joyeeta Mondal",
    image: images.profile.src,
    story:
      "I love all the designs they provide. Also the team is very helpful and professional in their work. I would recommend it to anyone",
    color: "#BF4AD2",
  },
  {
    name: "Mani Krishna Murthy",
    image: images.profile.src,
    story:
      "Range of templates to choose from. Very suitable for indian wedding invites.",
    color: "#362FF8",
  },
  {
    name: "Deepa AJ",
    image: images.profile.src,
    story:
      "Extremely helpful and supportive. I reached out to them late night and they accepted to support. Their turnaround time was few hours. Thanks Team.",
    color: "#9d4edd",
  },
  {
    name: "Abhi Kapoor",
    image: images.profile.src,
    story:
      "I love your platform!. It works really well and has the best designs for wedding cards. The unique designs are truly supreme, and the fact that it's free is a huge plus. You can find cards for all your events.",
    color: "#1d3557",
  },
  {
    name: "Sumit",
    image: images.profile.src,
    story:
      "I loved how easy to use this and also there are elegant design based on different themes! Loved it",
    color: "#e63946",
  },
];

export default function CustomerStories() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      // Calculate scroll amount based on card width (including gap)
      const cardWidth = scrollRef.current.offsetWidth / 3;
      const gap = 24; // 6 * 4px (Tailwind's gap-6)
      const scrollAmount = cardWidth + gap;

      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-16 overflow-visible">
      <div className="w-full pl-4 md:pl-6 lg:pl-8 pr-0">
        {/* Title and navigation buttons in one flex container */}
        <div className="flex flex-col md:flex-row items-start justify-between mb-[2rem] sm:mb-[3rem]">
          <div className="text-left w-full md:max-w-xl">
            <h2 className="text-[1rem] md:text-[2rem] font-[700] leading-relaxed text-[#0B214A] ">
              Customer Story
            </h2>
            <p className="text-[0.75rem] md:text-[1.25rem] font-[400] text-[#0B214A] ">
              A real story of creativity and ease in designing wedding invites.
              Joyful celebrations made simpler with MyWeddinglyInvites.
            </p>
          </div>
        </div>

        {/* Customer cards container */}
        <div className="py-0">
          <div
            ref={scrollRef}
            className="flex overflow-x-auto overflow-y-visible scroll-smooth gap-8 no-scrollbar pb-4"
            style={{
              scrollSnapType: "x mandatory",
            }}
          >
            {customers.map((c, i) => (
              <div
                key={i}
                className="flex-shrink-0 snap-start w-[250px] h-[205px] md:w-[415px]  md:h-[280px]"
                style={{
                  scrollSnapAlign: "start",
                }}
              >
                <CustomerCard customer={c} />
              </div>
            ))}
          </div>
        </div>
        <div
          className="flex justify-end w-full"
          style={{ marginTop: "-128px" }}
        >
          <div
            className="h-[128px] md:[276px] bg-[#FFEEF2]"
            style={{
              width: "80%",
              borderTopLeftRadius: "16px",
              borderBottomLeftRadius: "16px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
          ></div>
        </div>
      </div>
    </section>
  );
}
